

<kendo-formfield>
  <kendo-label [text]="caption | translate"></kendo-label>
  <kendo-textarea 
    [ngClass]="{'fx-fill': settings.fxFill, 'scrollable': settings.scrollable}"  
    [value]="displayValue"
    (valueChange)="onInputChange($event)"
    (blur)="onInputBlur()"
    [rows]="settings.rows"
    [disabled]="isDisabled"
    width="auto">
  </kendo-textarea>
  <kendo-textarea-suffix fxLayout="row" fxLayoutAlign="end center">
    <kendo-label [text]="('claims-center.claimsSearch.massSearchItemsCount' | translate) + ': ' + splittedItemsCount"></kendo-label>
  </kendo-textarea-suffix>
</kendo-formfield>
